/**
 * Created by shubham on 8/5/18.
 */

import { Component, ViewChild, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../../../shared/services/http.service';
import { SessionHandler } from '../../../shared/services/session-handler.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { MdDialog,MdDialogRef  } from '@angular/material';
import { DialogComponent } from '../../../dialog/dialog.component';
import { CommonService } from '../../../shared/services/common.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AdminListPage } from "../adminList-datatable/adminList-page";
import { APPCONFIG } from '../../../config';
import { AdminListDashboardResultService } from '../adminListDashboardResultService';
import {TranslateService} from 'ng2-translate';

@Component({
    selector: 'adminList',
    template: require('./adminList.component.html')
})
export class AdminListComponent {

    @ViewChild(DatatableComponent) table: DatatableComponent;
    dialogRef;
    userDetails:any;
    page = new AdminListPage();
    tableRows :any = [];
    filters:any = {};
    rows:any;
    adminListData = [];
    temp = [];
    showTable:boolean = true;
    isSystemAdmin:boolean = false;
    isBUManager:boolean = false;
    isRegionalAdmin:boolean = false;
    isServiceOwner:boolean = false;
    isTradePartner:boolean = false;
    isSubUser:boolean = false;
    selected = [];
    StatusData: any;
    selectedStatusId: boolean;
    adminRoles: any;
    defaulAdminId: any;
    adminListText: any;
    FiltersForm: FormGroup;
    firstName = '';
    email = '';
    wpassId = '';
    isDisabled = false;
    dataTableMessage = {'selectedMessage':'','totalMessage':''};

    constructor(private router: Router, private httpService:HttpService, private sessionHandler:SessionHandler, public dialog: MdDialog,
                private formBuilder: FormBuilder, private serverResultsService: AdminListDashboardResultService, private commonService: CommonService, 
                private translate: TranslateService) {

        this.adminListText = 'adminList';

        //Assign Active or Inactive status
        this.StatusData = [
            {
                "id": true,
                "code": "ACTIVE",
                "name": "Active"
            }, {
                "id": false,
                "code": "INACTIVE",
                "name": "Inactive"
            }
        ];
        this.selectedStatusId = true;

        this.page.pageNumber = 0;
        this.page.size = 20;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));

        if(this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0){
            if(this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            } else if(this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }

        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if(this.isSystemAdmin){
            this.getAdminRoles();
        } else{
            this.getUserList();
        }

        //Call when approve/delete from ApproveRejectComponent/ActiveInactiveComponent to get the updated list.
        this.commonService.adminList.subscribe((value) => {
            this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
        });
    }

    public getAdminRoles(){
        this.httpService.getRequest('superUserOperationsApi/v1/adminRoles').subscribe(
            res => { this.saveAdminRoles(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveAdminRoles(res){
        if(res && res.items){
            this.adminRoles = res.items;
            for(let a in this.adminRoles){
                if(this.adminRoles[a]['code'] == APPCONFIG.BUManager){
                    this.defaulAdminId = this.adminRoles[a]['id'];
                }
            }
            if(!this.defaulAdminId) {
                this.defaulAdminId = this.adminRoles[0]['id'];
            }
            this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
        }else {
            this.httpService.onEnd();
        }
    }

    buildForm() {
        this.FiltersForm = this.formBuilder.group({
            firstName: this.formBuilder.control({value: '', disabled: this.isDisabled}),
            email: this.formBuilder.control({value: '', disabled: this.isDisabled}),
            wpassId: this.formBuilder.control(''),
        });
        this.FiltersForm.valueChanges.subscribe(data => {
            this.firstName = this.FiltersForm.get('firstName').value;
            this.email = this.FiltersForm.get('email').value;
            this.wpassId = this.FiltersForm.get('wpassId').value;
        });
    }

    disablefields(value: String) {
        if(value != ''){
            this.FiltersForm.controls['firstName'].setValue('');
            this.FiltersForm.controls['email'].setValue('');
            this.FiltersForm.controls['firstName'].disable();
            this.FiltersForm.controls['email'].disable();
        } else{
            this.FiltersForm.controls['firstName'].enable();
            this.FiltersForm.controls['email'].enable();
        }
    }

    public search(){
        this.filters['offSet'] = 0;
        this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
    }

    public resetSearch(){
        this.FiltersForm.controls['firstName'].enable();
        this.FiltersForm.controls['email'].enable();
        this.FiltersForm.reset();
        this.firstName = '';
        this.email = '';
        this.wpassId = '';
        this.search();
    }

    public getUsersList(filter, selectedStatus, defaulAdminId, email, firstName, wpassId ){
        this.httpService.getRequest("superUserOperationsApi/v1/admin/list?limit="+filter.limit+"&offset="+filter.offSet+"&role="+defaulAdminId+"&active="+selectedStatus+"&email="+email+"&firstName="+firstName+"&wpassId="+wpassId).subscribe(
            res => { this.saveUserList(res,filter); },
            err => { this.httpService.onEnd();}
        );
    }

    public getUserList = function () {
        this.showTable = false;
    }

    public saveUserList = function(res, filter){
        if(res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if(res && Object.keys(res).length > 0 ){
                this.adminListData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;

                if(this.adminListData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.adminListData.list) {
                        if(this.isSystemAdmin){
                            this.rows[data] = {};
                            this.rows[data]['id'] = this.adminListData.list[data]['id'];
                            this.rows[data]['Name'] = this.adminListData.list[data]['firstName'] +' '+this.adminListData.list[data]['lastName'];
                            this.rows[data]['roleName'] = this.adminListData.list[data]['roleName'];
                            this.rows[data]['email'] = this.adminListData.list[data]['email'];
                            this.rows[data]['emailVerified'] = this.adminListData.list[data]['emailVerified'];

                            if(this.adminListData.list[data]['userId_WPASS']){
                                this.rows[data]['userId_WPASS'] = this.adminListData.list[data]['userId_WPASS'];
                            } else {
                                this.rows[data]['userId_WPASS'] = null;
                            }

                            if(this.adminListData.list[data]['pendingSubUserCount']){
                                this.rows[data]['pendingSubUserCount'] = this.adminListData.list[data]['pendingSubUserCount'];
                            } else {
                                this.rows[data]['pendingSubUserCount'] = 0;
                            }

                            this.rows[data]['languageId'] = this.adminListData.list[data]['languageId'];
                            this.rows[data]['languageName'] = 'Language';

                            if(this.adminListData.list[data]['active'] == true){
                                this.rows[data]['status'] = 'Active';
                            } else{
                                this.rows[data]['status'] = 'Inactive';
                            }

                            this.rows[data]['active'] = this.adminListData.list[data]['active'];
                            this.rows[data]['createdAt'] = this.adminListData.list[data]['createdAt'];
                            this.rows[data]['updatedAt'] = this.adminListData.list[data]['updatedAt'];
                        } else{
                            //For Other Service Partner's
                            this.rows[data] = {};
                        }
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else{
                    this.showTable = false;
                }

                let finalRows = [];
                for(let f in this.rows){
                    if(f != 'offset' && f !='totalCount' && this.rows[f]){
                        finalRows.push(this.rows[f]);
                    }
                    if(f == 'offset'){
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if(f == 'totalCount'){
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset']/this.page.size },finalRows,filter);
                this.httpService.onEnd();
            }
        }
    }

    /**
     * Populate the table with new data based on the page number
     * @param page The page to select
     */
    public setPage(pageInfo,rows,filter){
        this.page.pageNumber = pageInfo.offset;
        if(rows.length != 0){
            this.serverResultsService.getResults(this.page,rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if(!filter){
                    if(Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']){
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getUsersList(this.filters, this.selectedStatusId, this.defaulAdminId, this.email, this.firstName, this.wpassId);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }

    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
    }

    ngOnInit(){
        this.buildForm();

        this.translate.get('total').subscribe((res: string) => {
            this.dataTableMessage.totalMessage=res;
        });
        this.translate.get('selected').subscribe((res: string) => {
            this.dataTableMessage.selectedMessage=res;
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/adminManagement/adminList/adminList.component.ts